// Tenant preference helpers — admin views only. SuperAdmin has no per-tenant prefs.

const DEFAULTS = {
  water_label:       'CWA',
  electricity_label: 'CEB',
  water_unit:        'm3',
  electricity_unit:  'KWH',
  gas_unit:          'm3',
  currency:          'Rs.',
  currency_position: 'before',
  date_format:       'd M Y',
  timezone:          'Indian/Mauritius',
  delivery_hour:     22,
  wma_volume_ratio:  1.0,
  signatory_name:    'The Syndic',
  email_languages:   ['en', 'fr']
}

export { DEFAULTS as PREFERENCE_DEFAULTS }

// Returns merged prefs object (localStorage + defaults fallback)
export function getPreferences () {
  try {
    return Object.assign({}, DEFAULTS, JSON.parse(localStorage.getItem('preferences') || '{}'))
  } catch (e) {
    return Object.assign({}, DEFAULTS)
  }
}

// Meter-reading unit label; m3 rendered as m³
export function unitLabel (serviceTypeId, prefs) {
  const p = prefs || getPreferences()
  const raw = serviceTypeId === 1 ? p.water_unit
    : serviceTypeId === 2 ? p.electricity_unit
    : serviceTypeId === 3 ? p.gas_unit
    : 'units'
  return raw === 'm3' ? 'm³' : raw
}

// Billing unit label — gas always KG per billing spec
export function billingUnitLabel (serviceTypeId, prefs) {
  return serviceTypeId === 3 ? 'KG' : unitLabel(serviceTypeId, prefs)
}




// WEBPACK FOOTER //
// ./src/utils/preferences.js